import {
  deriveTitleAndUnitsFromColumnNames,
  groupFieldNamesByCommonFeature,
} from "components/athena/CsvColumnNameParsing";
import { groupByField } from "extensions/groupBy";

import { getHighchartOptions, HighchartPlotline } from "./HighchartOptions";
import { deriveAxisFromColumnDefinitions } from "./HighchartOptionsFromCsv";

export interface DevicePackDataPoint {
  device_id: string;
  unit_id: string;
  timestamp_utc: string;
  key: string;
  [fieldName: string]: number | string;
}
export const getHighchartOptionsFromRealtimeData = (
  currentDataFields: string[],
  deviceData: DevicePackDataPoint[],
  plotLines: HighchartPlotline[],
  getNow: () => number
) => {
  const currentDataFieldsByCommonFeature = groupFieldNamesByCommonFeature(
    currentDataFields
  );
  const dataGroupedByDeviceId = groupByField(deviceData, "device_id");
  const dataCutOffOnDayAgo = getNow() - 1000 * 60 * 60 * 24;
  return Object.values(currentDataFieldsByCommonFeature).map((dataFields) => {
    const { title, columnDefinitions } = deriveTitleAndUnitsFromColumnNames(
      dataFields
    );
    const {
      yAxis,
      columnDefinitionsWithAxisIndex,
    } = deriveAxisFromColumnDefinitions(columnDefinitions);

    const dataBySeries = Object.fromEntries(
      columnDefinitionsWithAxisIndex.flatMap((columnDefinition) =>
        Object.entries(dataGroupedByDeviceId).map(([deviceId, deviceData]) => [
          // deviceId is inserted again here to display, because we haven't included
          // it in the column names (if we were dealing with CSV data)
          `${deviceId} ${columnDefinition.title}`.trim(),
          {
            yAxisIndex: columnDefinition.yAxisIndex,
            dataPoints: deviceData
              .map((data) => [
                Date.parse(data.timestamp_utc),
                data[columnDefinition.columnName] as number,
              ])
              .filter(([date]) => date > dataCutOffOnDayAgo),
          },
        ])
      )
    );

    return getHighchartOptions({
      title,
      dataBySeries,
      plotLines,
      yAxis: yAxis,
    });
  });
};
